import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Types from '../components/Types';

var ParamsTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ParamsTable, _React$Component);

  function ParamsTable() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ParamsTable.prototype;

  _proto.getTableRows = function getTableRows(parentProperties) {
    return parentProperties.map(function (item, index) {
      var name = item.name,
          types = item.types,
          defaultVal = item.defaultVal,
          description = item.description,
          properties = item.properties;
      var props;

      if (properties) {
        props = properties.slice();
        props.pop(); // must remove last item
      }

      return /*#__PURE__*/React.createElement("tr", {
        key: "tr-" + index,
        className: "comment"
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("p", {
        className: "name"
      }, name)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Types, {
        data: types,
        defaultVal: defaultVal
      })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("p", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: description
        }
      }), props && /*#__PURE__*/React.createElement(ParamsTable, {
        properties: props,
        isProperties: true
      })));
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        properties = _this$props.properties,
        isProperties = _this$props.isProperties,
        isPropertyTitle = _this$props.isPropertyTitle;

    if (properties.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: isProperties ? 'properties' : 'params-wrapper'
      }, /*#__PURE__*/React.createElement("h5", {
        className: "title"
      }, isProperties || isPropertyTitle ? 'PROPERTIES' : 'PARAMETERS'), /*#__PURE__*/React.createElement("table", {
        className: isProperties ? '' : 'params'
      }, /*#__PURE__*/React.createElement("colgroup", null, /*#__PURE__*/React.createElement("col", {
        className: "first-column"
      }), /*#__PURE__*/React.createElement("col", {
        className: "second-column"
      }), /*#__PURE__*/React.createElement("col", null)), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Type"), /*#__PURE__*/React.createElement("th", null, "Description"))), /*#__PURE__*/React.createElement("tbody", null, this.getTableRows(properties))));
    }

    return null;
  };

  return ParamsTable;
}(React.Component);

export default ParamsTable;